import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c967u6a4: FaireBrandEntity = {
  token: "b_c967u6a4",
  type: "brand",
  name: "Benoit's Design Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/9864a38928cbdb097c8b944dc3e3a6de276447033c0ff43ba180c2ddca9bc5f0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0cb54d903f46e62d247c3f30833ba4eb6775a6c547c613be684570b4d0b06bc1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9864a38928cbdb097c8b944dc3e3a6de276447033c0ff43ba180c2ddca9bc5f0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0cb54d903f46e62d247c3f30833ba4eb6775a6c547c613be684570b4d0b06bc1.jpeg",
  location: "Westbrook, ME, USA",
  minimumOrderDollars: 120,
  rating: 4.9,
  reviewCount: 64,
  isTopShop: true,
  isInsider: true,
  description:
    "Benoit’s Design Co. began with a simple idea: to create meaningful, handcrafted goods that people could hold, gift, and treasure. What started as a creative experiment—engraving a map of our family cottage on Casco Bay, Maine—has grown into a product line that celebrates stories, places, and moments people love most.\n\nToday, we’re a small, family-run team designing and producing everything in-house at our Maine workshop. From engraved glassware and felt pennants to wood illustrations and archival art prints, each piece is crafted with care, using U.S.-sourced materials and small-batch production methods.\n\nOur products are designed to spark nostalgia, pride, and connection—making them ideal keepsakes and gifts for your customers.\n\nThanks for considering Benoit’s Design Co. as part of your shop.\n—Greg & Christina Benoit",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:18.909Z",
    importedBy: "entity-db-cli",
  },
};
